import NyCharterAgreementForm from './views/ny-charter-agreement-form';
import NyCharterAgreementGrid from './views/ny-charter-agreement-grid';
import NyGeoLocationsForm from './views/ny-geo-locations-form';
import NyGeoLocationsGrid from './views/ny-geo-locations-grid';
import NySystemUsersProfileForm from './views/ny-system-users-profile-form';
import NySystemUsersPasswordForm from './views/ny-system-users-password-form';
import NySystemUsersGrid from './views/ny-system-users-grid';
import NySystemUsersForm from './views/ny-system-users-form';
import NyItineraryForm from './views/ny-itinerary-form';
import NyItineraryGrid from './views/ny-itinerary-grid';
import auth from "./auth";
import { createRouter, createWebHashHistory } from "vue-router";

import Home from "./views/home-page";
import Profile from "./views/profile-page";
import Tasks from "./views/tasks-page";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

import NYParameters from '../ny-globals'

import navigation from './app-navigation';

function loadView(view) {
  return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Home
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Tasks
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In"
      },
      component: loadView("login-form")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up"
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password"
      },
      component: loadView("change-password-form")
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }, 
    {
      path: "/ny-itinerary-grid",
      name: "ny-itinerary-grid",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NyItineraryGrid
    }, 
    {
      path: "/ny-itinerary-form",
      name: "ny-itinerary-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NyItineraryForm
    }, 
    {
      path: "/ny-system-users-form",
      name: "ny-system-users-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NySystemUsersForm
    }, 
    {
      path: "/ny-system-users-grid",
      name: "ny-system-users-grid",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NySystemUsersGrid
    }, 
    {
      path: "/ny-system-users-password-form",
      name: "ny-system-users-password-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NySystemUsersPasswordForm
    }, 
    {
      path: "/ny-system-users-profile-form",
      name: "ny-system-users-profile-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NySystemUsersProfileForm
    }, 
    {
      path: "/ny-geo-locations-grid",
      name: "ny-geo-locations-grid",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NyGeoLocationsGrid
    }, 
    {
      path: "/ny-geo-locations-form",
      name: "ny-geo-locations-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NyGeoLocationsForm
    }, 
    {
      path: "/ny-charter-agreement-grid",
      name: "ny-charter-agreement-grid",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NyCharterAgreementGrid
    }, 
    {
      path: "/ny-charter-agreement-form",
      name: "ny-charter-agreement-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NyCharterAgreementForm
    }
  ],
  history: createWebHashHistory()
});

router.beforeEach(async (to, from, next) => {

  if (to.name === "login-form" && !auth.loggedIn()) {
    try {
      //console.log(1)
        await auth.getMe(); 
        //console.log(2)
    } catch (error) {
        //console.error('There is no me :', error);
    }
  }

  if (to.name === "login-form" && auth.loggedIn()) {
    next({ name: "home" });
  }

  //console.log(NYParameters.loggedUser)
  if (NYParameters.loggedUser.system_user_group_ids) {
    navigation.map((item) => {
      //item.visible = item.userlevel.includes(NYParameters.loggedUser.system_user_group_id)
      //const categoryIdsFromString = NYParameters.loggedUser.system_user_group_ids.split(',');
      //console.log(categoryIdsFromString)
      item.visible = NYParameters.loggedUser.system_user_group_ids.split(',').map(Number).some(id => item.userLevel.includes(id));
    })
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
